<template>
  <div>
    <div id="content" class="content animated slideInRight delay-1s">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                Cadastrar Veículos
                <span class="required_fields">
                  <span class="required">*</span> Campos obrigatórios
                </span>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-9">
                  <form id="form">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="brand">
                            <span class="required">*</span> Marca:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="vehicle.brand"
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="model">
                            <span class="required">*</span> Modelo:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="vehicle.model"
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="color">
                            <span class="required">*</span> Cor
                          </label>
                          <v-select
                            :options="colors"
                            label="description"
                            :reduce="(colors) => colors.description"
                            class="style-chooser"
                            v-model="vehicle.color"
                          >
                            <div slot="no-options">Carregando...</div>
                          </v-select>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="category">
                            <span class="required">*</span> Categoria:
                          </label>
                          <select
                            v-model="vehicle.category_id"
                            class="form-control"
                          >
                            <option
                              v-for="category in categories"
                              :value="category.id"
                              :key="category.id"
                            >
                              {{ category.description }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group">
                          <label for="board">
                            <span class="required">*</span> Placa:
                          </label>
                          <input
                            style="text-transform: uppercase"
                            type="text"
                            class="form-control"
                            v-mask="'AAA#X##'"
                            v-model="vehicle.board"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="vehicle_caster_id">
                            <span class="required">*</span> Rodízio:
                          </label>
                          <input
                            v-for="caster in filteredCasters"
                            class="form-control"
                            v-model="caster.day_week"
                            :key="caster.id"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="type">
                            <span class="required">*</span> Tipo:
                          </label>
                          <select
                            v-model="vehicle.vehicle_type_id"
                            class="form-control"
                          >
                            <option
                              v-for="type in types"
                              :value="type.id"
                              :key="type.id"
                            >
                              {{ type.description }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="combustible">
                            <span class="required">*</span> Combustível:
                          </label>
                          <select
                            v-model="vehicle.combustible"
                            class="form-control"
                            id="combustible"
                            name="combustible"
                            tabindex="5"
                          >
                            <option value="Etanol">Etanol</option>
                            <option value="Gasolina">Gasolina</option>
                            <option value="Flex">Flex</option>
                            <option value="GNV">GNV</option>
                            <option value="Diesel">Diesel</option>
                            <option value="Eletrico">Elétrico</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="renavam_code">Código Renavam:</label>
                          <input
                            type="text"
                            class="form-control"
                            v-mask="'###########'"
                            v-model="vehicle.renavam_code"
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="col-md-3">
                  <div class="car-img">
                    <img
                      v-if="previewImage"
                      :src="previewImage"
                      class="uploading-image car"
                      alt="Imagem do Veículo"
                    />
                    <img
                      v-else
                      :src="vehicle.photo"
                      class="car"
                      alt="Imagem do Veículo"
                    />
                    <qrcode-vue
                      v-if="vehicle.board"
                      class="code"
                      :value="vehicle.board"
                      level="H"
                    ></qrcode-vue>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="chassi">Chassi:</label>
                    <input
                      type="text"
                      class="form-control"
                      maxlength="17"
                      v-model="vehicle.chassi"
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="year_of_manufacture">
                      <span class="required">*</span> Ano de Fab:
                    </label>
                    <input
                      type="text"
                      v-mask="'####'"
                      class="form-control"
                      v-model="vehicle.year_of_manufacture"
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="model_year">
                      <span class="required">*</span> Ano Mod:
                    </label>
                    <input
                      type="text"
                      v-mask="'####'"
                      class="form-control"
                      v-model="vehicle.model_year"
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="current_km">
                      <span class="required">*</span> KM Atual:
                    </label>
                    <the-mask
                      class="form-control"
                      v-model="vehicle.current_km"
                      :mask="['####', '#.###', '##.###', '###.###']"
                    />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="branch_id">
                      <span class="required">*</span> Filial:
                    </label>
                    <select v-model="vehicle.branch_id" class="form-control">
                      <option
                        v-for="branch in branches"
                        :value="branch.id"
                        :key="branch.id"
                      >
                        {{ branch.description }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="description">
                      <span class="required">*</span> Descrição:
                    </label>
                    <textarea
                      class="form-control"
                      v-model="vehicle.description"
                      maxlength="40"
                      rows="3"
                      placeholder="Seja breve, 40 caractéres."
                    ></textarea>
                  </div>
                </div>
                <br />
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="photo" id="pass">Foto do Veículo</label>
                    <br />
                    <small>
                      Lembrando que são
                      <b>150 pixels</b> de altura e <b>200 pixels</b> de lagura
                      por padrão!
                    </small>
                    <input
                      id="photo"
                      type="file"
                      class="form-control"
                      name="photo"
                      @change="uploadImage"
                      accept="image/*"
                      placeholder
                    />
                  </div>
                  <hr />
                  <div class="block text-right">
                    <a class="btn btn-add" @click="save">
                      Salvar
                      <i class="fa fa-save"></i>
                    </a>
                    <router-link to="/vehicles" class="btn btn-back">
                      <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
import QrcodeVue from "qrcode.vue";
import vSelect from "vue-select";

export default {
  data() {
    return {
      previewImage: null,
      vehicle: {
        description: "",
        board: "",
        branch_id: "",
        brand: "",
        color: "",
        model: "",
        year_of_manufacture: "",
        model_year: "",
        renavam_code: "",
        chassi: "",
        combustible: "",
        current_km: "",
        photo: "",
        vehicle_qr_code_photo: "",
        category_id: "",
        vehicle_type_id: "",
        color_id: "",
      },
      checklist_item: {
        id: "",
        description: "",
        checked: "",
      },
      checklist_items: [],
      link_checklist_items: [],
      categories: [],
      casters: [],
      branches: [],
      types: [],
      checkeds: [],
      colors: [],
    };
  },
  computed: {
    filteredModels: function () {
      return this.models.filter((x) => x.brand == this.vehicle.brand);
    },
    filteredCasters: function () {
      console.log("teste");
      if (this.vehicle.board.length >= 7) {
        var end_plate = this.vehicle.board.charAt(
          this.vehicle.board.length - 1
        );
        return this.casters.filter((x) => x.end_plate == end_plate);
      }
    },
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let photo = document.getElementById("photo");
      let vehicleBoard = document.getElementById("vehicle_board");

      fd.append("description", self.vehicle.description);
      fd.append("board", self.vehicle.board);
      fd.append("branch_id", self.vehicle.branch_id);
      fd.append("brand", self.vehicle.brand);
      fd.append("color", self.vehicle.color);
      fd.append("model", self.vehicle.model);
      fd.append("year_of_manufacture", self.vehicle.year_of_manufacture);
      fd.append("model_year", self.vehicle.model_year);
      fd.append("vehicle_status_id", "1");

      fd.append("renavam_code", self.vehicle.renavam_code);
      fd.append("current_km", self.vehicle.current_km);

      fd.append("chassi", self.vehicle.chassi);
      fd.append("combustible", self.vehicle.combustible);

      var current_km = self.vehicle.current_km;

      if (photo.files[0]) {
        fd.append("photo", photo.files[0] ? photo.files[0] : "");
      }

      fd.append("category_id", self.vehicle.category_id);
      fd.append("vehicle_type_id", self.vehicle.vehicle_type_id);

      if (self.vehicle.id) {
        fd.append("id", self.vehicle.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "vehicles";

      let fd = self.makeFormData();

      if (self.vehicle.id) {
        api += "/" + self.vehicle.id;
      }

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/vehicles");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.previewImage = e.target.result;
        console.log(this.previewImage);
      };
    },
    getVehicle: function (id) {
      const self = this;
      const api = self.$store.state.api + "vehicles/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.vehicle = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCategories: function (id) {
      const self = this;
      const api = self.$store.state.api + "categories/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.categories = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCasters: function (id) {
      const self = this;
      const api = self.$store.state.api + "vehicleCasters/";

      self.$http
        .get(api)
        .then((response) => {
          self.casters = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getBranches: function (id) {
      const self = this;
      const api = self.$store.state.api + "branches/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.branches = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getTypes: function (id) {
      const self = this;
      const api = self.$store.state.api + "vehicleTypes/";

      self.$http
        .get(api)
        .then((response) => {
          self.types = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getChecklistItems: function (id) {
      const self = this;
      const api = self.$store.state.api + "checklistItems/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.checklist_items = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCheckeds: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "link_category_checklist_items/?category_id=" +
        id;

      self.$http
        .get(api)
        .then((response) => {
          let checked_items = response.data.data;
          for (let i = 0; i < checked_items.length; i++) {
            self.checkeds[i] = checked_items[i].checklist_item_id;
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getColors: function (id) {
      const self = this;
      const api = self.$store.state.api + "colors/";

      self.$http
        .get(api)
        .then((response) => {
          self.colors = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    // uploadImage(e){
    //     const image = e.target.files[0];
    //     const reader = new FileReader();
    //     reader.readAsDataURL(image);
    //     reader.onload = e =>{
    //         this.previewImage = e.target.result;
    //         console.log(this.previewImage);
    //     };
    // },
  },
  mounted: function () {
    const self = this;
    self.getCategories();
    self.getCasters();
    self.getBranches();
    self.getTypes();
    self.getChecklistItems();
    self.getColors();
    let id = self.$route.params.id;
    self.getCheckeds(self.vehicle.category_id);
    if (id) {
      self.getVehicle(id);
    }
  },
  components: {
    BaseCrud,
    QrcodeVue,
    vSelect,
  },
};
</script>
<style scoped>
#most {
  display: none;
}

#pass:hover #most {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Vehicle/Add.vue